import React from "react";
import styles from "./spinning_arrow.module.css";

const SpinningArrow = ({
  badgeCount,
  onClick,
  arrowSrc = "/assets/fleche-2.png",
  logoSrc = "/assets/logo-loader.png",
  size = "normal"
}) => {
  return (
    <div
      className={`${styles.notificationIcon} ${styles[size]}`}
      onClick={onClick}
      title="Commande en cours"
    >
      <div className={styles.spinningCircle}>
        <img
          src={arrowSrc}
          alt="Flèche rotative"
          className={styles.circleIcon}
        />
      </div>
      <img
        src={logoSrc}
        alt="Logo"
        className={styles.logoImage}
      />
      {badgeCount > 0 && (
        <span className={styles.iconBadge}>{badgeCount}</span>
      )}
    </div>
  );
};

export default SpinningArrow;